// src/lib/services.js
import api, { withBusiness } from "./api";

/**
 * Obține lista de servicii pentru business-ul curent
 * GET /api/b/:businessId/services/
 *
 * options:
 *  - include_inactive: boolean (default false)
 */
export async function listServices(options = {}) {
  const { include_inactive = false } = options || {};

  const url = withBusiness("/b/:businessId/services/");
  const { data } = await api.get(url, {
    params: include_inactive ? { include_inactive: 1 } : undefined,
  });
  // backend-ul poate returna fie direct array, fie {results: []}
  return Array.isArray(data?.results) ? data.results : data;
}

/**
 * Creează un serviciu nou
 * POST /api/b/:businessId/services/
 */
export async function createService(payload) {
  const url = withBusiness("/b/:businessId/services/");
  const { data } = await api.post(url, payload);
  return data;
}

/**
 * Actualizează un serviciu existent
 * PUT sau PATCH /api/b/:businessId/services/{id}/
 */
export async function updateService(id, payload) {
  const url = withBusiness(`/b/:businessId/services/${id}/`);
  // dacă backend-ul tău acceptă doar PUT, schimbă api.patch în api.put
  const { data } = await api.patch(url, payload);
  return data;
}

/**
 * Șterge un serviciu
 * DELETE /api/b/:businessId/services/{id}/
 */
export async function deleteService(id) {
  const url = withBusiness(`/b/:businessId/services/${id}/`);
  await api.delete(url); // la 409 va arunca și ajungi în catch din index.jsx
  return true;
}
